import React from 'react';

export function elementWasNotClicked(element: HTMLElement, event: MouseEvent): boolean {
    return element && !element.contains(event.target as HTMLElement);
}

type UseDetectClickOutsideElementProps = {
    element: HTMLElement;
    onClickOutside: (event: MouseEvent) => unknown;
    enabled?: boolean;
};

export function useDetectClickOutsideElement({
    element,
    onClickOutside,
    enabled,
}: UseDetectClickOutsideElementProps): void {
    React.useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (enabled && elementWasNotClicked(element, event)) {
                onClickOutside(event);
            }
        }
        window.addEventListener('mousedown', handleClickOutside);
        return () => {
            window.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClickOutside, element, enabled]);
}
